import { useContext } from 'react';

import { ContextMenuContext } from './context';

export const useContextMenu = () => useContext(ContextMenuContext);
